import { SVGAttributes } from 'react'

import { ContactsIcon, PreferencesIcon, UserIcon, AddressIcon } from '../icons'

type MenuAccountButton = {
  id: string,
  icon: React.ForwardRefExoticComponent<SVGAttributes<SVGSVGElement> & React.RefAttributes<SVGSVGElement>>,
  title: string,
  description: string,
  route: string,
  outsideOfReact?: boolean,
  hasSmallTextOnDesktop?: boolean
}

export type ItemsMyAccount = {
  account?: boolean
  contacts?: boolean
  addresses?: boolean
  complementaryData?: boolean
}

export const ACCOUNT: MenuAccountButton = {
  id: 'click-personal-data-link',
  icon: UserIcon,
  title: 'Dados Pessoais',
  description: 'Gerencie seus dados pessoais: nome e CPF.',
  route: '/dados-pessoais'
}

export const CONTACTS: MenuAccountButton = {
  id: 'click-contacts-link',
  icon: ContactsIcon,
  title: 'Contatos',
  description: 'Gerencie e-mails e telefone cadastrados.',
  route: '/meus-contatos'
}

export const ADDRESS: MenuAccountButton = {
  id: 'click-address-link',
  icon: AddressIcon,
  title: 'Endereços',
  description: 'Altere ou adicione endereços de entregas.',
  route: '/enderecos'
}

export const COMPLEMENTARY_DATA: MenuAccountButton = {
  id: 'click-additional-data-link',
  icon: PreferencesIcon,
  title: 'Dados Complementares',
  description: 'Gerencie seus endereços, senha e interesses.',
  route: '/dados-complementares',
  outsideOfReact: true,
  hasSmallTextOnDesktop: true
}

export const getItemsMyAccount = (
  itemsMyAccount: ItemsMyAccount
) => {
  const activeItems = []

  if (itemsMyAccount?.account) {
    activeItems.push(ACCOUNT)
  }

  if (itemsMyAccount?.contacts) {
    activeItems.push(CONTACTS)
  }

  if (itemsMyAccount?.addresses) {
    activeItems.push(ADDRESS)
  }

  if (itemsMyAccount?.complementaryData) {
    activeItems.push(COMPLEMENTARY_DATA)
  }

  return activeItems
}
